import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { format, parseISO } from 'date-fns';
import SideBar from '../../SideBar';
import HeaderSection from '../../HeaderSection';
import '../../../../assets/css/loader.css';   
import { reviewTemplateList,updateReviewTemplateName,deleteReviewTemplate } from "../../../../utils/reviewApi";
import InstallWidgetPopup from "../../../../components/InstallWidgetPopup";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import AppWidgetViewDetail from "../../../../components/AppWidgetViewDetail";

export default function MyAppStoreReview() {
    const navigate = useNavigate();
    const [api_template_data, setApiTemplateData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [openTemplateMenuId, setOpenTemplateMenuId] = useState(null); 
    const [renameTemplateId, setRenameTemplateId] = useState(null);
    const [newTemplateName, setNewTemplateName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isInstallWidgetPopupOpen, setIsInstallWidgetPopupOpen] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    // Toggle Template menu
    const toggleTemplateMenu = (uuid) => {
        setOpenTemplateMenuId(openTemplateMenuId === uuid ? null : uuid); 
    };

    // Open rename Template popup
    const openRenameTemplatePopup = (template) => {
        setRenameTemplateId(template.uuid);
        setNewTemplateName(template.name);
        setOpenTemplateMenuId(null); 
        document.body.classList.add("popup-open");
    };

    const closeRenameTemplatePopup = () => {
        setRenameTemplateId(null)
        document.body.classList.remove("popup-open");
    };

    const handleEditClick = (uuid) => {
        navigate(`/customer/edit/app-store-reviews/${uuid}`);
    }

    const handleInstallClick = (template) => {
        setSelectedTemplate(template);
        setIsInstallWidgetPopupOpen(true);
        document.body.classList.add("popup-open");
    };


    // Handle rename Template submission
    const handleUpdateTemplate = async () => {
        setIsSubmitting(true);
    
        try {
            // Prepare the payload
            const payload = {
                template_id: renameTemplateId,
                template_name: newTemplateName,
            };
    
            // API Call
            const api_response = await updateReviewTemplateName(payload);
    
            // Check API Response
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    document.body.classList.remove("popup-open");
                    setRenameTemplateId(null); 
                    setIsSubmitting(false); 
                    // Fetch latest template data
                    fetchTemplateApiData();
                }, 2000);
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        } finally {
            setIsSubmitting(false); 
        }
    };
    
    // Function to fetch template Api data
    const fetchTemplateApiData = async () => {
        setIsLoading(true);
        try {
            // You can change this to any app type you want to fetch templates for
            let app_type = "AppStore_Review";
            const result = await reviewTemplateList(app_type);
            if (result && result.data) {
                setApiTemplateData(result);
            } else {
                setApiTemplateData({ data: [] });
            }
        } catch (error) {
            setApiTemplateData({ data: [] });
            //console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Fetch data on component mount
    useEffect(() => {
        fetchTemplateApiData();
    }, []);
    

    //Delete Template
    const deleteTemplate = async (uuid) => {
        setOpenTemplateMenuId(null); 
        setIsSubmitting(true); 
        
        try {
            // Prepare the payload
            const payload = {
                template_id: uuid,
            };
    
            // API Call
            const api_response = await deleteReviewTemplate(payload);
            // Check API Response
            if (api_response.status === true) {
                toast.success(api_response.message);

                // Fetch latest template data
                fetchTemplateApiData();
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        } finally {
            setIsSubmitting(false); 
        }
    };

    //Duplicate or clone Template
    const duplicateTemplate = async (uuid) => {
        alert("Under Progress");
        setOpenTemplateMenuId(null); 
    }

    return (
        <>
            <div className="container-scroller">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />
                        <div className="google-reviews-saction-one row">
                            <div className="google-left-one col-md-6 col-12">
                                <h2>App Store Reviews</h2>
                                <ul>
                                    <li><Link to="/customer/apps/app-store-reviews" className="active"><img src={`${process.env.PUBLIC_URL}/images/icon-1.png`} alt="icon-1"/>Widgets</Link></li>
                                </ul>
                            </div>

                            {/* Call Widget View Detail */}
                            <AppWidgetViewDetail app_name="App Store Reviews" app_type="AppStore_Review" app_slug="app-store-reviews"/>
                        </div>
                        {isLoading ? (
                            <div className="loader-container">
                                <div className="spinner"></div>
                                <p>Loading please wait...</p>
                            </div>
                        ) : api_template_data?.data?.length > 0 ? (
                        <>
                        <div className="google-reviews-saction-tow">
                            <div className="search-box-row-all">
                                <div className="search-box-row-left">
                                    <div className="search-box-inner">
                                        <button><i className="fa fa-search" aria-hidden="true"></i></button>
                                        <input type="search" placeholder="Search anything here..."/>
                                    </div>
                                </div>
                                <div className="search-box-row-right">
                                    <CheckCurrentPlan from_page={false} app_name="App Store Reviews" app_type="AppStore_Review" app_slug="app-store-reviews">
                                        <Link to="/customer/create/app-store-reviews" className="create-widget-button"><span>+</span> Create Widget</Link>
                                    </CheckCurrentPlan>
                                </div>
                            </div>
                            <div className="reviews-box-all">
                                <div className="row">
                                    {api_template_data.data.map((template) => (
                                        <div className={`col-md-3 ${template.views_detail?.is_limit_reached ? "widget-limit-reached" : ""}`} key={template.id}>
                                            <div className={`reviews-box-inner full_height_image ${template.views_detail?.is_limit_reached ? "disabled-card" : ""}`}>
                                                <div className="reviews-image">
                                                    <img src={template.template_image} alt="temp-image" />
                                                </div>
                                                <div className="reviews-content">
                                                    <h3>{template.name}</h3>
                                                    <div className="dot-icon">
                                                        <button onClick={() => toggleTemplateMenu(template.uuid)} disabled={template.views_detail?.is_limit_reached}>
                                                            <img src={`${process.env.PUBLIC_URL}/images/icon-6.png`} alt="icon-6" />
                                                        </button>
                                                    </div>
                                                    {/* Toggle Dropdown */}
                                                    {openTemplateMenuId === template.uuid && (
                                                        <div className="template-menu-open">
                                                            <ul className="text-sm">
                                                                <li className="p-2" onClick={() => openRenameTemplatePopup(template)}>Rename Widget</li>
                                                                <li className="p-2" onClick={() => duplicateTemplate(template.uuid)}>Duplicate</li>
                                                                <li className="p-2" onClick={() => deleteTemplate(template.uuid)}>Delete Widget</li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                    <p>{template.created_at ? `Created ${format(parseISO(template.created_at), "MMM d, yyyy")}` : ""}</p>
                                                    <div className="edit-install-button"> 
                                                        <button onClick={() => handleEditClick(template.uuid)} className="edit-button" disabled={template.views_detail?.is_limit_reached}>
                                                            <img src={`${process.env.PUBLIC_URL}/images/icon-7.png`} alt="icon-7" />Edit
                                                        </button> 
                                                        <button className="install-button" onClick={() => handleInstallClick(template)} disabled={template.views_detail?.is_limit_reached}>
                                                            <img src={`${process.env.PUBLIC_URL}/images/icon-8.png`} alt="icon-8" />Install
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {/* Rename Popup */}
                            {renameTemplateId !== null && (
                                <div className="fixed top-0 left-0 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden">
                                    <div className="bg-white p-3 rounded-lg shadow-lg">
                                        <h3 className="text-lg font-semibold">Rename Widget</h3>
                                        <label>Widget Name</label>
                                        <input
                                            type="text"
                                            className="border p-2 w-full mt-2"
                                            value={newTemplateName}
                                            onChange={(e) => setNewTemplateName(e.target.value)}
                                        />
                                        <div className="mt-3 flex justify-end">
                                            <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameTemplatePopup}>
                                                Cancel
                                            </button>
                                            <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={handleUpdateTemplate} disabled={isSubmitting}>
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/*If install popup is open*/}
                            {isInstallWidgetPopupOpen && selectedTemplate && (
                                <InstallWidgetPopup setIsInstallWidgetPopupOpen={setIsInstallWidgetPopupOpen} template={selectedTemplate} />
                            )}
                        </div>
                        </>
                        ) : (
                            <div className="widget-almosthere">
                                <div className="widget-almosthere-inner">
                                    <div className="icon-blank-image">
                                        <img src={`${process.env.PUBLIC_URL}/images/illustration.svg`} alt="illustration" />
                                    </div>
                                    <h2>Your first widget is almost here!</h2>
                                    <p>Create a captivating widget with the help of ready-made templates or configure a unique widget from scratch.</p>
                                    <div className="create-widget-black">
                                        <Link to="/customer/create/app-store-reviews">+ Create Widget</Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
